import admanToast from '../Alert/util/admanToast';
import { VALID_FORMATS, VALID_MAX_SIZE } from './constants';

export const validateFile = (file: File): boolean => {
  if (!VALID_FORMATS.includes(file.type)) {
    admanToast.error('File format should be .mp4 or .mov');
    return false;
  } else if (file.size > VALID_MAX_SIZE) {
    admanToast.error('File size should be less then 3 GB');
    return false;
  }

  return true;
};

export const changeExtensionToLowerCase = (name: string = ''): string => {
  const fileExtension = name.split('.').at(-1);
  let fileName = name;

  if (fileExtension) {
    fileName = name.replace(/\.[^.]+$/, `.${fileExtension.toLowerCase()}`);
  }

  return fileName;
};
